import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[cmpsCoachingCommitmentSummaryNote]',
})
export class CmpsCommitmentSummaryNoteDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}
